<template>
  <v-form
    ref="form"
    @submit.prevent="submit"
    v-model="formValid"
    style="min-height: 400px;"
  >
    <v-row v-if="isShowUserCosts && modality == 'agricola'">
      <TableCostAgricola
        v-model="formCosts"
        value="formCosts"
        @edit="editRow"
        @delete="deleteRow"
        @duplicate="duplicateRow"
      />
    </v-row>
    <v-row v-if="isShowUserCosts && modality == 'cafezal'">
      <TableCostCafezal
        v-model="formCosts"
        value="formCosts"
        @edit="editRow"
        @delete="deleteRow"
        @duplicate="duplicateRow"
      />
    </v-row>
    <v-col v-if="currentQuotation.cancelada_em == null">
      <v-row>
        <v-col
          cols="12"
          md="auto"
          class="mb-xs-5 mb-sm-5"
          v-if="!enableCost && isShowUserCosts"
        >
          <BaseButton
            class="secondary text-uppercase subtitle-2 font-weight-bold"
            style="width: 95%"
            @click="addNewCost()"
          >
            <v-icon class="pr-3 add-icon">fa-plus</v-icon>
            ADICIONAR COTAÇÃO
          </BaseButton>
        </v-col>
        <v-col
          cols="12"
          md="auto"
          class="mb-xs-5 mb-sm-5 ml-2"
          v-if="!enableCost && isEmployeeUser"
        >
          <BaseButton
            v-if="!enablePeriod && isShowUserCosts"
            class="secondary text-uppercase subtitle-2 font-weight-bold"
            style="width: 100%"
            @click="addNewPeriod()"
          >
            <v-icon class="pr-3 add-icon">fa-plus</v-icon>
            ADICIONAR AVISO
          </BaseButton>
        </v-col>
      </v-row>
      <v-row v-if="enablePeriod" class="d-flex column">
        <v-col md="12">
          <v-textarea
            v-if="showTextArea"
            v-model="textInput"
            rows="5"
          ></v-textarea>
        </v-col>
        <v-col cols="2" class="mr-4">
          <BaseButton
            v-html="'Cancelar'"
            class="secondary--textbutton -border"
            width="100%"
            outlined
            @click="cancelText"
          />
        </v-col>
        <v-col cols="2">
          <BaseButton
            v-html="'Salvar'"
            class="white--text secondary"
            width="100%"
            @click="saveText"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-row
      v-if="isEmployeeUser && enableCost && modality == 'agricola'"
      class="addCost"
    >
      <QuotationAddCostAgricola
        v-model="formCosts"
        value="formCosts"
        :itemIndex="itemIndex"
        @update:enableCost="updateEnableCost"
        @cancel="cancelEdit"
      />
    </v-row>
    <v-row
      v-if="isEmployeeUser && enableCost && modality == 'cafezal'"
      class="addCost"
    >
      <QuotationAddCostCafezal
        v-model="formCosts"
        value="formCosts"
        :itemIndex="itemIndex"
        @update:enableCost="updateEnableCost"
        @cancel="cancelEdit"
      />
    </v-row>
    <BaseFooter v-if="currentQuotation.cancelada_em == null">
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pr-0 pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotation"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3" v-if="isEmployeeUser">
          <BaseButton
            v-html="'PRÓXIMO'"
            class="white--text secondary"
            width="100%"
            @click="submit()"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import { requiredInput, maxLengthNumber } from "@/utils/rules.js";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import CompanyMixin from "@/mixins/CompanyMixin";
import _ from "lodash";
import TableCostAgricola from "./TableCostAgricola.vue";
import TableCostCafezal from "./TableCostCafezal.vue";
import QuotationAddCostAgricola from "../components_agro/QuotationAddCostAgricola";
import QuotationAddCostCafezal from "./QuotationAddCostCafezal.vue";

export default {
  data: () => ({
    formValid: true,
    loading: false,
    requiredInput,
    timeout: null,
    maxLengthNumber,
    enableCost: false,
    enablePeriod: false,
    textInput: "Período de semeadura recomendado pelo ZARC",
    showTextArea: true,
    inputSave: false,
    itemIndex: -1
  }),
  components: {
    TableCostAgricola,
    TableCostCafezal,
    QuotationAddCostAgricola,
    QuotationAddCostCafezal
  },
  computed: {
    ...mapState(["loadingStatus"]),
    ...mapState("quotation", ["insuredByNameOrCPFCNPJ", "currentQuotation"]),
    ...mapState("me", ["userIsEmployee", "myInfo"]),
    formCosts: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    isShowUserCosts() {
      return (
        this.formCosts.quotationCosts.length > 0 ||
        this.formCosts.quotationCostsCafezal.lenght > 0 ||
        this.isEmployeeUser
      );
    },
    isEmployeeUser() {
      return this.userIsEmployee;
    }
  },
  mixins: [LoadingRequest, CompanyMixin],
  methods: {
    ...mapActions("quotation", ["requestInsuredByNameOrCPFCNPJ"]),
    ...mapActions(["hasLoading", "showAlertNotification"]),
    addNewCost() {
      this.itemIndex = -1;
      this.enableCost = true;
    },
    cancelEdit() {
      this.itemIndex = -1;
      this.enableCost = false;
    },
    updateEnableCost(value) {
      this.enableCost = value;
    },
    addNewPeriod() {
      this.enablePeriod = true;
      this.showTextArea = true;
    },
    saveText() {
      this.enablePeriod = false;
      this.showTextArea = true;
      this.inputSave = true;
    },
    cancelText() {
      this.userInput = "";
      this.enablePeriod = false;
      this.inputSave = false;
    },
    searchInput(value) {
      clearTimeout(this.timeout);
      let vm = this;
      // fazer requisição apenas se tiver valor no input
      if (value.target.value.length >= 3)
        this.timeout = setTimeout(function() {
          vm.fetchInsured(value);
          vm.timeout = null;
        }, 1000);
    },
    submit() {
      if (
        this.formCosts.quotationCosts.length == 0 &&
        this.formCosts.quotationCostsCafezal.length == 0
      ) {
        this.showAlertNotification({
          message: "É necessário inserir ao menos uma cotação.",
          type: "error"
        });
        return;
      }
      if (this.$refs.form.validate()) {
        // Verificar se o elemento escolhido tem os mesmos valores da tabela conforme
        // o id, se não tiver, devo deixar null o id
        const item = this.insuredByNameOrCPFCNPJ.find(
          x => x.id == this.value.id
        );
        this.value.id = item?.nome == this.value.nome ? this.value.id : null;

        let text = this.textInput.replace(/\n/g, "  ");
        if (this.inputSave == true) {
          this.value.textInput = text;
        } else {
          this.value.textInput = "";
        }

        this.$emit("submit", this.value);
      }
    },
    cancelQuotation() {
      this.$emit("cancel");
    },
    async fetchInsured(value) {
      // se for busca por documento (CPF ou CNPJ),
      // deixar apenas numeros para realizar a busca
      const payload = {
        query:
          value.target.id == "cpfCnpjInsuredQuotation"
            ? value.target.value.replace(/[^0-9]/g, "")
            : value.target.value
      };
      // Não sei porque ele perde o valor, então devo guardar ele
      this.formInsured.numero_documento =
        value.target.id === "cpfCnpjInsuredQuotation"
          ? value.target.value
          : this.formInsured.numero_documento;
      await this.withLoading(this.requestInsuredByNameOrCPFCNPJ(payload));
      document.getElementById(value.target.id).focus();
      const type =
        value.target.id == "cpfCnpjInsuredQuotation"
          ? "numero_documento"
          : "nome";

      this.autocompleteFormAccordingInput(payload.query, type);
    },
    autocompleteFormAccordingInput(value, input) {
      // Se selecionar um elemento do back-end, deve-se autocompletar
      // a tabela inteira conforme o elemente selecionado
      const item = this.insuredByNameOrCPFCNPJ.find(x => x[input] == value);
      if (item) {
        this.formInsured = this.mergeProperties(
          _.cloneDeep(item),
          this.formInsured
        );
        this.formInsured.numero_documento = this.formatCpfOrCnpf(
          item.numero_documento
        );
      }
    },
    editRow(item) {
      const index = this.getItemIndex(item);
      if (index > -1) {
        this.cancelEdit();
        this.openEdit(this.getItemIndex(item));
      }
    },
    openEdit(index) {
      setTimeout(() => {
        this.itemIndex = index;
        this.enableCost = true;
      }, 10);
    },
    deleteRow(item) {
      const index = this.getItemIndex(item);
      if (index > -1) {
        this.cancelEdit();
        if (this.modality == "cafezal") {
          this.formCosts.quotationCostsCafezal.splice(index, 1);
        } else {
          this.formCosts.quotationCosts.splice(index, 1);
        }
      }
    },
    duplicateRow(item) {
      let cost = _.cloneDeep(item);
      cost.id = null;
      if (this.modality == "cafezal") {
        this.formCosts.quotationCostsCafezal.push(cost);
      } else {
        this.formCosts.quotationCosts.push(cost);
      }
    },
    getItemIndex(item) {
      if (this.modality == "cafezal") {
        if (
          !(
            this.formCosts &&
            this.formCosts.quotationCostsCafezal &&
            Array.isArray(this.formCosts.quotationCostsCafezal)
          )
        ) {
          return -1;
        }

        return this.formCosts.quotationCostsCafezal.indexOf(item);
      } else {
        if (
          !(
            this.formCosts &&
            this.formCosts.quotationCosts &&
            Array.isArray(this.formCosts.quotationCosts)
          )
        ) {
          return -1;
        }

        return this.formCosts.quotationCosts.indexOf(item);
      }
    }
  },
  props: {
    value: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    formCost: {
      type: Object
    },
    modality: {
      type: String
    }
  },
  watch: {
    "formInsured.numero_documento"(newValue, oldValue) {
      // Tenho que garantir que o valor antigo não é o
      // mesmo do valor atual para não entrar num loop infinito
      // e como o valor pode ser tanto um objeto ou string,
      // preciso fazer teste para ambos.
      if (!newValue || newValue == oldValue) return;
      const item = newValue?.id || newValue.replace(/[^0-9]/g, "");
      const type = newValue?.id ? "id" : "numero_documento";
      this.autocompleteFormAccordingInput(item, type);
    },
    "formInsured.nome"(newValue, oldValue) {
      // Tenho que garantir que o valor antigo não é o
      // mesmo do valor atual para não entrar num loop infinito
      // e como o valor pode ser tanto um objeto ou string,
      // preciso fazer teste para ambos.
      if (!newValue || newValue == oldValue) return;
      const item = newValue?.id || newValue;
      const type = newValue?.id ? "id" : "nome";
      this.autocompleteFormAccordingInput(item, type);
    }
  }
};
</script>
<style lang="sass">
.addCost
  display: flex
  align-items: center
  justify-content: center
</style>
